import(/* webpackMode: "eager" */ "/app/public/icon/icon-cry-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-cry.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-dislike.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-heart-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-heart.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-laugh-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-laugh.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-like.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-thumb-down.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-thumb-up.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/boc-rang-su.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/dan-rang-su.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/nieng-rang-tham-my.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/trong-rang-implant.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/bac-si/[...slug]/client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/not-found/client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/phong-kham/[slug]/tin-tuc/[id]/client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/phong-kham/[slug]/tin-tuc/client.js");
